module.exports = __webpack_public_path__ + "static/science_waves-3b38461770f4810f26001414ee4ae36f.svg";